import React, { useEffect, useState } from 'react';
import "./App.css";
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Servicios from './components/Servicios/Servicios';
import CasosDeExito from './components/CasosDeExito/CasosDeExito';
import Contacto from './components/Contacto/Contacto';
import Footer from './components/Footer/Footer';
import { Toaster } from 'react-hot-toast';
import axios from 'axios';

function App() {

    const [token, setToken] = useState(null);
    const [data, setData] = useState({navbar: [], hero: {}, servicios: [], casosDeExito: [], footer:[]});

    useEffect(()=>{

        async function fetchData(){

            let promise;
            let token = "";

            try{
                promise = await axios.get("http://peuma-ig.com.ar/servicios/gettoken.php?client_id=2c7ddd98a5d012b79290fee86ff95401&secret_id=25ec225b93bed02d005bc7036835762b")
            } catch(e){
                console.log(e)
            }

            if(promise.data.response_code === 200){
                token = promise.data.response_desc;
            }

            setToken(token);

            await Promise.all([
                axios.get(`http://peuma-ig.com.ar/servicios/getmenues.php?token=${token}&id_division=1`),
                axios.get(`http://peuma-ig.com.ar/servicios/getcontenidos.php?token=${token}&id_division=2`),
                axios.get(`http://peuma-ig.com.ar/servicios/getcategorias.php?token=${token}&id_division=3`),
                axios.get(`http://peuma-ig.com.ar/servicios/getcategorias.php?token=${token}&id_division=4`)
            ]).then((values)=>{
                setData({
                    navbar: values[0].data,
                    hero: values[1].data[0],
                    servicios: values[2].data,
                    casosDeExito: values[3].data,
                    footer: values[0].data
                })
            })
        }

        fetchData();

    },[])

  return (
    <div className="app">
        <Toaster/>
        <Navbar data={data.navbar} />
        <Hero data={data.hero}/>
        <Servicios data={data.servicios}/>
        <CasosDeExito data={data.casosDeExito} />
        <Contacto token={token} />
        <Footer data={data.navbar}/>

        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/WhatsApp_icon.png/598px-WhatsApp_icon.png" alt="Whatsapp Icon" className='wppicon' onClick={()=>{window.open(`https://web.whatsapp.com/send?phone=+5491123897241`)}}/>

    </div>
  );
}

export default App;
